import styled from '@emotion/styled'
import { Theme, keyframes } from '@emotion/react'
import { FontAwesomeIcon, FontAwesomeIconProps } from '@fortawesome/react-fontawesome'
import { faSpinnerThird } from '@fortawesome/pro-regular-svg-icons'
import { SizeProp } from '@fortawesome/fontawesome-svg-core'

// const spinframes = keyframes`
// 	from { transform: rotate(0deg); }
// 	to   { transform: rotate(360deg); }
// `

const LoadingIcon = styled(FontAwesomeIcon)({
	animationDuration: '.5s',
})

type LoadingProps = {
	size?: SizeProp
	props?: FontAwesomeIconProps
} & { theme?: Theme }

const Loading = ({size = '4x', theme, ...props}: LoadingProps) => 
	<LoadingIcon size={size} icon={faSpinnerThird} spin={true} {...props} />

export default Loading
